import { COLORS } from 'app/constants'
import React from 'react'
import Switch from 'react-switch'

const CSwitch = ({ checked, setChecked, style = {} }) => {
	return (
		<Switch
			checked={checked}
			onChange={() => setChecked(!checked)}
			onColor={COLORS.BTN_HOVER}
			onHandleColor={COLORS.white}
			handleDiameter={15}
			uncheckedIcon={false}
			checkedIcon={false}
			height={10}
			width={25}
			className="react-switch"
			id="material-switch"
		/>
	)
}

export default React.memo(CSwitch)
